import React from 'react';
import '../styles/team.css'
import sisipho from '../media/sisipho.jpeg'
import kamva from '../media/kamva.jpeg'
import CapsLock from '../media/CapsLockTechnologies.png'
import AOS from 'aos';
import 'aos/dist/aos.css'; // You can also use <link> for styles
// ..
AOS.init();

const Team = () => {
    return (
        <div className='teamContainer mx-auto'>
            <div className="header">
                <div className="title text-color-white">Our Expert Team</div>
                <img src="../media/kamva.jpeg" alt="" />
            </div>
            <div className="row justify-content-center pb-5">
                <div className="card col-md-3 mt-100" data-aos="zoom-in-right" >
                    <div className="card-content">
                        <div className="card-body p-0">
                            <div className="profile"> <img src={sisipho} alt="" /> </div>
                            <div className="card-title mt-4">Sisipho Breakfast<br /> <small>Chief Executive Director</small> </div>
                            <div className="card-subtitle">
                                <p> <small className="text-muted">I expected anything less than perfect for the team of experts. They are the best team ever! </small> </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card col-md-3 mt-100" data-aos="zoom-in">
                    <div className="card-content">
                        <div className="card-body p-0">
                            <div className="profile"> <img src={kamva} alt="" /> </div>
                            <div className="card-title mt-4">Kamvelihle Kalani<br /> <small>Chief Executive Officer</small> </div>
                            <div className="card-subtitle">
                                <p><small className="text-muted"> I really enjoyed working with them, they are Group of Professionals and they know what they're Doing </small> </p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="card col-md-3 mt-100" data-aos="zoom-in">
                    <div className="card-content">
                        <div className="card-body p-0">
                            <div className="profile"> <img src={CapsLock} alt="" /> </div>
                            <div className="card-title mt-4">CapsLock Technologies (Pty) Ltd<br /> <small>IT Department</small> </div>
                            <div className="card-subtitle">
                                <p><small className="text-muted"> Leveraging technologies to drive a better IT experience.</small> </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Team